import keys from '../../../../config/keys';

export default {
  '461': keys.BACK,
  '13': keys.ENTER,
  '-1': keys.EXIT,

  '37': keys.LEFT,
  '38': keys.UP,
  '39': keys.RIGHT,
  '40': keys.DOWN,

  '33': keys.CH_UP,
  '34': keys.CH_DOWN,

  // Magic wheel
  '1536': keys.SHOW_POINTER,
  '1537': keys.HIDE_POINTER,

  // Color
  '403': keys.RED,
  '404': keys.GREEN,
  '405': keys.YELLOW,
  '406': keys.BLUE,

  // Playback
  '415': keys.PLAY,
  '19': keys.PAUSE,
  '412': keys.RW,
  '417': keys.FF,
  '413': keys.STOP,

  // Numeric
  '49': keys.ONE,
  '50': keys.TWO,
  '51': keys.THREE,
  '52': keys.FOUR,
  '53': keys.FIVE,
  '54': keys.SIX,
  '55': keys.SEVEN,
  '56': keys.EIGHT,
  '57': keys.NINE,
  '48': keys.ZERO,
};
